// export const basciUrl = 'https://api2.apitask.cc'
export const basciUrl = 'https://ts.smwooltask.cc'